export default __webpack_public_path__ + "static/media/lloyd doggett.5a03a8bf.jpg";